import { render, staticRenderFns } from "./postTask.vue?vue&type=template&id=b1214b60&"
import script from "./postTask.vue?vue&type=script&lang=js&"
export * from "./postTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports